import api from "./api";

const timetableService = {
  getAll: (params) => api.get("/timetables", { params }),

  getByCourse: (params) =>
    api.get("/timetables/by-course", { params }),

  getById: (id) => api.get(`/timetables/${id}`),

  create: (data) => api.post("/timetables", data),

  update: (id, data) => api.put(`/timetables/${id}`, data),

  remove: (id) => api.delete(`/timetables/${id}`),
};

export default timetableService;
